import { CLIENT_PAGES } from '~constants/pages';
import dynamicImportComponent, { IMPORTS_NAMES } from '~utils/dynamicImports';

const HomeImport = () => import('./screens/Home');
const CheckoutImport = () => import('./screens/Checkout');
const OrdersImport = () => import('./screens/Orders');
const PurchaseSucessImport = () => import('./screens/PurchaseSuccess');
const PurchaseFailureImport = () => import('./screens/PurchaseFailure');
const ProcessingPurchaseImport = () => import('./screens/ProcessingPurchase');
const ProcessingAddCardImport = () => import('./screens/ProcessingAddCard');
const AddCardSuccessImport = () => import('./screens/AddCardSuccess');
const AddCardFailureImport = () => import('./screens/AddCardFailure');
const ProfileImport = () => import('./screens/Profile');
const TermsAndConditionsImport = () => import('./screens/TermsAndConditions');
const MercatTermsAndConditionsImport = () => import('./screens/MercatTermsAndConditions');
const NPSImport = () => import('./screens/NPS');

export const Home = dynamicImportComponent(HomeImport, IMPORTS_NAMES.home);
export const Checkout = dynamicImportComponent(
  CheckoutImport,
  IMPORTS_NAMES.checkout,
  CLIENT_PAGES.CHECKOUT.basePath
);
export const Orders = dynamicImportComponent(OrdersImport, IMPORTS_NAMES.orders, CLIENT_PAGES.ORDERS.path);
export const PurchaseSuccess = dynamicImportComponent(
  PurchaseSucessImport,
  IMPORTS_NAMES.purchaseSuccess,
  CLIENT_PAGES.PURCHASE_SUCCESS.path
);
export const PurchaseFailure = dynamicImportComponent(
  PurchaseFailureImport,
  IMPORTS_NAMES.purchaseFailure,
  CLIENT_PAGES.PURCHASE_SUCCESS.path
);
export const ProcessingPurchase = dynamicImportComponent(
  ProcessingPurchaseImport,
  IMPORTS_NAMES.processingPurchase,
  CLIENT_PAGES.PROCESSING_PURCHASE.path
);
export const ProcessingAddCard = dynamicImportComponent(
  ProcessingAddCardImport,
  IMPORTS_NAMES.processingAddCard,
  CLIENT_PAGES.PROCESSING_ADD_CARD.path
);
export const AddCardSuccess = dynamicImportComponent(
  AddCardSuccessImport,
  IMPORTS_NAMES.addCardSuccess,
  CLIENT_PAGES.ADD_CARD_SUCCESS.path
);
export const AddCardFailure = dynamicImportComponent(
  AddCardFailureImport,
  IMPORTS_NAMES.addCardFailure,
  CLIENT_PAGES.ADD_CARD_FAILURE.path
);
export const Profile = dynamicImportComponent(
  ProfileImport,
  IMPORTS_NAMES.profile,
  CLIENT_PAGES.PROFILE.path
);
export const TermsAndConditions = dynamicImportComponent(
  TermsAndConditionsImport,
  IMPORTS_NAMES.termsAndConditions,
  CLIENT_PAGES.TERMS_AND_CONDITIONS.path
);
export const MercatTermsAndConditions = dynamicImportComponent(
  MercatTermsAndConditionsImport,
  IMPORTS_NAMES.mercatTermsAndConditionsImport,
  CLIENT_PAGES.MERCAT_TERMS_AND_CONDITIONS.path
);
export const NPS = dynamicImportComponent(NPSImport, IMPORTS_NAMES.NPS, CLIENT_PAGES.NPS.path);

export const QUERY_PARAMS = {
  STORE: 'store',
  DISPATCH_METHOD: 'dispatch-method'
};
